import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  BorderOutlined,
  CheckCircleFilled,
  CheckSquareOutlined,
  DownloadOutlined,
  FileTextOutlined,
  DownOutlined,
  ExclamationCircleOutlined,
  FilterOutlined,
  InfoCircleOutlined,
  MenuOutlined,
  PhoneOutlined,
  QuestionCircleOutlined,
  RightOutlined,
  SearchOutlined,
  ShareAltOutlined,
  ShoppingCartOutlined,
  UpOutlined,
  UserOutlined,
  VerticalAlignBottomOutlined
} from '@ant-design/icons'
import { asStyledIcon, UtilTypes } from '@briq/core'

import CaseBlue from '../assets/icons/case-blue.svg?react'
import CaseOrange from '../assets/icons/case-orange.svg?react'
import EmptyCircleSvg from '../assets/icons/empty-circle.svg?react'
import FilledFilterIcon from '../assets/icons/icon-filled-filter-blue.svg?react'
import FilterIcon from '../assets/icons/icon-filter-blue.svg?react'
import TrashWhite from '../assets/icons/trash-2-white.svg?react'
import TrashBlue from '../assets/icons/icon-trash-blue.svg?react'
import CopyBlue from '../assets/icons/icon-copy-blue.svg?react'

import CloseSquare from '../assets/icons/atom-icon-s-close-square.svg?react'
import ArrowRightBlue from '../assets/icons/arrow-right-blue.svg?react'
import FilePlus from '../assets/icons/atom-icon-s-file-plus.svg?react'
import FilePlusWhite from '../assets/icons/atom-icon-s-file-plus-white.svg?react'
import Save from '../assets/icons/atom-icon-s-save.svg?react'
import Star from '../assets/icons/atom-icon-s-star.svg?react'
import StarFull from '../assets/icons/atom-icon-s-star-full.svg?react'
import StarFullWhite from '../assets/icons/atom-icon-s-star-full-white.svg?react'
import Info from '../assets/icons/atom-icon-s-info.svg?react'
import Chat from '../assets/icons/chats.svg?react'
import AiAgentHorizontal from '../assets/icons/ai-agent-horizontal.svg?react'
import AiAgent from '../assets/icons/ai-agent.svg?react'

const EmptyCircle = ({ ...rest }) => (
  <span className="anticon" {...rest}>
    <EmptyCircleSvg />
  </span>
)

export const icons: UtilTypes.Dictionary<React.ComponentType<any>> = {
  QuestionCircleOutlined: asStyledIcon(QuestionCircleOutlined),
  ShoppingCartOutlined: asStyledIcon(ShoppingCartOutlined),
  UserOutlined: asStyledIcon(UserOutlined),
  SearchOutlined: asStyledIcon(SearchOutlined),
  ArrowLeftOutlined: asStyledIcon(ArrowLeftOutlined),
  ArrowRightOutlined: asStyledIcon(ArrowRightOutlined),
  RightOutlined: asStyledIcon(RightOutlined),
  InfoCircleOutlined: asStyledIcon(InfoCircleOutlined),
  MenuOutlined: asStyledIcon(MenuOutlined),
  DownloadOutlined: asStyledIcon(DownloadOutlined),
  FileTextOutlined: asStyledIcon(FileTextOutlined),
  PhoneOutlined: asStyledIcon(PhoneOutlined),
  ShareAltOutlined: asStyledIcon(ShareAltOutlined),
  CheckCircleFilled: asStyledIcon(CheckCircleFilled),
  ExclamationCircleOutlined: asStyledIcon(ExclamationCircleOutlined),
  DownOutlined: asStyledIcon(DownOutlined),
  UpOutlined: asStyledIcon(UpOutlined),
  BorderOutlined: asStyledIcon(BorderOutlined),
  CheckSquareOutlined: asStyledIcon(CheckSquareOutlined),
  FilterOutlined: asStyledIcon(FilterOutlined),
  VerticalAlignBottomOutlined: asStyledIcon(VerticalAlignBottomOutlined),
  CloseSquare: CloseSquare,
  FilledFilter: FilledFilterIcon,
  Filter: FilterIcon,
  CaseOrange: CaseOrange,
  CaseBlue: CaseBlue,
  Trash: TrashWhite,
  TrashBlue: TrashBlue,
  CopyBlue: CopyBlue,

  EmptyCircle: EmptyCircle,
  ArrowRightBlue: ArrowRightBlue,
  FilePlus: FilePlus,
  FilePlusWhite: FilePlusWhite,
  Save: Save,
  Star,
  StarFull,
  StarFullWhite,
  Info,
  Chat,
  AiAgentHorizontal,
  AiAgent
}
